import { render, staticRenderFns } from "./jingdong.vue?vue&type=template&id=73347f19&scoped=true"
import script from "./jingdong.vue?vue&type=script&lang=js"
export * from "./jingdong.vue?vue&type=script&lang=js"
import style0 from "./jingdong.vue?vue&type=style&index=0&id=73347f19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73347f19",
  null
  
)

export default component.exports